export class ProjectApi {
    constructor(settings) {
        this.url = settings.url;
    }
    /**
     * Gets scenario details.
     *
     * @param options The options.
     * @returns The scenario details.
     */
    async getScenario(options) {
        const scenarioUrl = `scenario/${options.id}`;
        const url = `${this.url}${scenarioUrl}`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        return await response.json();
    }
    /**
     * Gets shared scenarios for the given scenario.
     *
     * @param options The options.
     * @returns
     */
    async getSharedScenariosForScenario(options) {
        const url = `${this.url}scenario/${options.scenarioId}/share`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            }
        });
        return (await response.json());
    }
    /**
     * Gets a shared scenario.
     *
     * @param options The options.
     * @returns The shared scenario details.
     */
    async getSharedScenario(options) {
        const url = `${this.url}shared/scenario/${options.id}/`;
        const response = await fetch(url);
        return (await response.json());
    }
    /**
     * Creates a new shared scenario.
     * @param options
     * @returns
     */
    async postSharedScenario(options) {
        const url = `${this.url}scenario/${options.scenarioId}/share`;
        const body = "";
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.text();
    }
    /**
     * Deletes a shared scenario.
     * @param options
     * @returns
     */
    async deleteSharedScenario(options) {
        const url = `${this.url}shared/scenario/${options.id}/`;
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken
            }
        });
        return response.ok;
    }
    /**
     * Gets an update matrix.
     *
     * @param options The options.
     * @returns T
     */
    async updateTripScenario(options) {
        const url = `${this.url}scenario/trips/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return response.ok;
    }
    /**
     * Creates a new matrix.
     *
     * @param options The options.
     * @returns The new id.
     */
    async createMatrix(options) {
        const response = await fetch(`${this.url}scenario/trips/${options.tripScenarioId}/matrix`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(options.data)
        });
        return await response.json();
    }
    /**
     * Updates a matrix.
     *
     * @param options The options.
     * @returns T
     */
    async updateMatrix(options) {
        const url = `${this.url}scenario/trips/${options.tripScenarioId}/matrix/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.json();
    }
    /**
     * Deletes a matrix.
     *
     * @param options The options.
     * @returns T
     */
    async deleteMatrix(options) {
        const url = `${this.url}scenario/trips/${options.tripScenarioId}/matrix/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return response.ok;
    }
    /**
     * Creates new matrix assignments.
     * @param options
     */
    async createMatrixAssignment(options) {
        const url = `${this.url}scenario/trips/${options.tripScenarioId}/matrix/${options.matrixId}/assignment/`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "text/plain",
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.text();
    }
    /**
     * Updates a matrix assignment.
     *
     * @param options The options.
     * @returns T
     */
    async updateMatrixAssignment(options) {
        const url = `${this.url}scenario/trips/${options.tripScenarioId}/assignment/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        // TODO: the response is probably better the complete matrix again with all details, we are doing a lot in this update.
        return response.ok;
    }
    /**
     * Deletes a matrix assignment.
     *
     * @param options
     * @returns
     */
    async deleteMatrixAssignment(options) {
        const url = `${this.url}scenario/trips/${options.tripScenarioId}/assignment/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return response.ok;
    }
    /**
     * Creates a new scenario.
     *
     * @param options
     * @returns
     */
    async createScenario(options) {
        const url = `${this.url}scenario`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(options.data)
        });
        return await response.json();
    }
    /**
     * Gets segments for the given trip scenario id.
     *
     * @param options
     * @returns
     */
    async getSegments(options, signal) {
        let url = `${this.url}scenario/trips/${options.tripScenarioId}/segments/${options.branchCommitId}`;
        if (typeof options.nextTripsCollectionId !== "undefined") {
            url = `${this.url}scenario/trips/${options.tripScenarioId}/segments/${options.branchCommitId}/trips/${options.nextTripsCollectionId}`;
        }
        const response = await fetch(url, {
            signal: signal,
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        return (await response.json());
    }
    /**
     * Gets the details for the project with the given id.
     *
     * @param options The options.
     * @returns The project details.
     */
    async getProject(options) {
        const url = `${this.url}project/${options.id}`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const p = await response.json();
        p.scenarios.forEach(scenario => {
            scenario.createdAt = new Date(scenario.createdAt);
            scenario.branch = scenario.branchId;
        });
        return p;
    }
    /**
     * Deletes then scenario with the given id.
     *
     * @param options The options.
     *
     * @returns True if the scenario was deleted.
     */
    async deleteScenario(options) {
        const url = `${this.url}scenario/${options.id}`;
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken
            }
        });
        return response.ok;
    }
    /**
     * Creates a new project.
     *
     * @param options The options.
     *
     * @returns The new project details.
     */
    async createProject(options) {
        const url = `${this.url}project`;
        const body = JSON.stringify({
            organizationId: options.organizationId,
            name: options.name,
            area: options.area,
            scenarios: options.scenarios
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.json();
    }
    /**
     * Deletes the project with the given id.
     *
     * @param options The options.
     *
     * @returns True if the project was deleted.
     */
    async deleteProject(options) {
        const url = `${this.url}project/${options.id}`;
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken
            }
        });
        return response.ok;
    }
    /**
     * Gets the current user's organizations.
     *
     * @param options The options.
     *
     * @returns The organizations the user has access to.
     */
    async getUserOrganizations(options) {
        const url = `${this.url}organization`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const json = await response.json();
        return json.organizations;
    }
    /**
     * Gets the project the current user has access to.
     *
     * @param options The options.
     *
     * @returns The projects.
     */
    async getUserProjects(options) {
        let url = `${this.url}project`;
        if (typeof options.q !== "undefined" && options.q.length > 0) {
            url = `${this.url}project?q=${options.q}`;
        }
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const json = await response.json();
        const projects = [];
        json.projects.forEach(p => {
            //p.client = p.clientId;
            p.createdAt = new Date(p.createdAt);
            p.lastModified = p.lastModified ? new Date(p.lastModified) : undefined;
            p.scenarios.forEach(scenario => {
                scenario.createdAt = new Date(scenario.createdAt);
            });
            projects.push(p);
        });
        return projects;
    }
    /**
     * Updates the project with the given id.
     *
     * @param options The options.
     *
     * @returns True if the project was update.
     */
    async updateProject(options) {
        const url = `${this.url}project/${options.id}`;
        const body = JSON.stringify(options.projectData);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        if (response.ok) {
            return true;
        }
        return false;
    }
    /**
     * Updates the given scenario.
     *
     * @param options The options.
     *
     * @returns True if the scenario was updated.
     */
    async updateScenario(options) {
        const url = `${this.url}scenario/${options.id}`;
        const body = JSON.stringify(options.scenarioData);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        if (response.ok) {
            return true;
        }
        return false;
    }
    /**
     * Creates a new reroute.
     *
     * @param options The options.
     *
     * @returns The new id for the reroute.
     */
    async createReroute(options) {
        const url = `${this.url}shared/reroute`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.text();
    }
    /**
     * Gets the details about a reroute.
     *
     * @param options The options.
     *
     * @returns The details.
     */
    async getReRoute(options) {
        const url = `${this.url}shared/reroute/${options.id}`;
        const headers = {};
        if (typeof options.accessToken !== "undefined") {
            headers.Authorization = "Bearer " + options.accessToken;
        }
        const response = await fetch(url, {
            headers: headers
        });
        if (!response.ok)
            return undefined;
        return (await response.json());
    }
    /**
     * Gets the details about a reroute.
     *
     * @param options The options.
     *
     * @returns The details.
     */
    async getProjectReRoutes(options) {
        const url = `${this.url}shared/project/${options.projectId}/reroute`;
        const headers = {};
        if (typeof options.accessToken !== "undefined") {
            headers.Authorization = "Bearer " + options.accessToken;
        }
        const response = await fetch(url, {
            headers: headers
        });
        if (!response.ok)
            return undefined;
        return (await response.json());
    }
    /// BELOW THIS NEEDS MORE WORK/THINKING
    /// BELOW THIS IS UNVERIFIED OR UNUSED
    async updateReroute(options) {
        const url = `${this.url}shared/reroute/${options.id}`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return response.ok;
    }
    /**
     * Deletes the given reroute.
     */
    async deleteReroute(options) {
        const url = `${this.url}shared/reroute/${options.id}`;
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            }
        });
        return response.ok;
    }
}
